"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Alert = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _core = require("@material-ui/core");

var Icons = _interopRequireWildcard(require("@zip/react-icons/fearless"));

var style = _interopRequireWildcard(require("./Alert.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Alert = function Alert(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      link = _ref.link,
      _ref$linkText = _ref.linkText,
      linkText = _ref$linkText === void 0 ? 'Learn more' : _ref$linkText,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "link", "linkText", "children"]);

  var theme = (0, _core.useTheme)();

  var variantIcon = function variantIcon() {
    var _theme$colors, _theme$colors2, _theme$colors3, _theme$colors4;

    switch (variant) {
      case 'info':
        return (0, _jsxRuntime.jsx)(Icons.InformationCircle, {
          width: 24,
          height: 24,
          fill: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.info
        });

      case 'error':
        return (0, _jsxRuntime.jsx)(Icons.WarningCircle, {
          width: 24,
          height: 24,
          fill: theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.danger
        });

      case 'success':
        return (0, _jsxRuntime.jsx)(Icons.CheckCircle, {
          width: 24,
          height: 24,
          fill: theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : _theme$colors3.success
        });

      case 'warning':
        return (0, _jsxRuntime.jsx)(Icons.WarningTriangle, {
          width: 24,
          height: 24,
          fill: theme === null || theme === void 0 ? void 0 : (_theme$colors4 = theme.colors) === null || _theme$colors4 === void 0 ? void 0 : _theme$colors4.warning
        });

      default:
        return null;
    }
  };

  return (0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    css: style.banner(variant)
  }, props), {}, {
    children: [variant !== 'default' && (0, _jsxRuntime.jsx)("div", {
      css: style.icon,
      children: variantIcon()
    }), (0, _jsxRuntime.jsxs)("div", {
      css: style.content,
      children: [children, link && (0, _jsxRuntime.jsx)("div", {
        css: style.link,
        children: (0, _jsxRuntime.jsx)("a", {
          href: link,
          target: "_blank",
          rel: "noopener noreferrer",
          children: linkText
        })
      })]
    })]
  }));
};

exports.Alert = Alert;
var _default = Alert;
exports["default"] = _default;